import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './viewDetailsBranch.module.css';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import BranchViewDetailsHeader from './header';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import useStyles from './styles';
import AboutDetails from './About/AboutDetails';
import Document from '../../../../assets/document.png';
import {
  deleteDigitalAsync,
  deleteSchoolAgreementAsync,
  deleteSchoolDocAsync,
  getAllSchoolAsync,
  updateAdminSchoolDigitalDeliverableAsync,
  updateSchoolAgreementAsync,
  updateSchoolDocsAsync,
  uploadFileAsync,
} from '../bccTeenybeansStore/bccTeenybeansStoreSlice';
import { toast } from 'react-toastify';
import UploadDocuments from './UploadDocuments';
import { Delete } from '@material-ui/icons';
import DigitalDelivarable from './DigitalDelivarable';
import CloseIcon from '@material-ui/icons/Close';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import GetAppIcon from '@material-ui/icons/GetApp';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1500 },
    items: 1,
    partialVisibilityGutter: 140,
  },
  tablet: {
    breakpoint: { max: 1500, min: 1024 },
    items: 1,
    partialVisibilityGutter: 90,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 50,
  },
};

const ViewDetails = () => {
  const classes = useStyles();
  const [activeAbout, setActiveAbout] = useState(true);
  const [activeAgreement, setActiveAgreement] = useState(false);
  const [activeDigital, setActiveDigital] = useState(false);
  const [activeSchoolDoc, setActiveSchoolDoc] = useState(false);
  const [adminMsgs, setAdminMsgs] = useState('');
  const [adminFile, setAdminFile] = useState('');
  const [show, setShow] = useState(false);
  const [hide, setHide] = useState(false);
  const [digitalId, setDigitalId] = useState('');
  const [docId, setDocId] = useState('');

  const dispatch = useDispatch();

  const { schoolData } = useSelector((state) => {
    const { teenybeansReducer } = state;
    return {
      schoolData: teenybeansReducer.allSchool
        ? teenybeansReducer.allSchool && teenybeansReducer.allSchool.data
        : [],
    };
  });

  const location = useLocation();
  const branchUniqueId = location.search.split('=');

  React.useEffect(() => {
    dispatch(getAllSchoolAsync());
  }, []);

  const singleSchoolData =
    schoolData && schoolData.find((o) => o._id === branchUniqueId[1]);

  const accessManage = [
    {
      grid: 5,
      title: 'Dashboard',
      value:
        singleSchoolData &&
        singleSchoolData.moduleAccess &&
        singleSchoolData.moduleAccess.DASHBOARD,
    },
    {
      grid: 7,
      title: 'Digital Deliverables',
      value:
        singleSchoolData &&
        singleSchoolData.moduleAccess &&
        singleSchoolData.moduleAccess.DIGITAL_DELIVERABLES,
    },
    {
      grid: 5,
      title: 'ROI',
      value:
        singleSchoolData &&
        singleSchoolData.moduleAccess &&
        singleSchoolData.moduleAccess.ROI,
    },
    {
      grid: 7,
      title: 'Methodology Training',
      value:
        singleSchoolData &&
        singleSchoolData.moduleAccess &&
        singleSchoolData.moduleAccess.METHODOLOGY_TRAINING,
    },
    {
      grid: 5,
      title: 'Teams',
      value:
        singleSchoolData &&
        singleSchoolData.moduleAccess &&
        singleSchoolData.moduleAccess.TEAMS,
    },
    {
      grid: 7,
      title: 'School Documents',
      value:
        singleSchoolData &&
        singleSchoolData.moduleAccess &&
        singleSchoolData.moduleAccess.SCHOOL_DOCUMENTS,
    },
    {
      grid: 5,
      title: 'Akadmy',
      value:
        singleSchoolData &&
        singleSchoolData.moduleAccess &&
        singleSchoolData.moduleAccess.AKADMY,
    },
    {
      grid: 7,
      title: 'Website Builder',
      value:
        singleSchoolData &&
        singleSchoolData.moduleAccess &&
        singleSchoolData.moduleAccess.WEBSITE_BUILDER,
    },
  ];

  const deleteAgreement = (id) => {
    dispatch(
      deleteSchoolAgreementAsync({ schoolId: branchUniqueId[1], agreement: id })
    )
      .unwrap()
      .then((res) => {
        dispatch(getAllSchoolAsync());
        toast.success('School Agreement Removed Successfully');
        setHide(false);
      })
      .catch((err) =>
        toast.error('something went wrong, school not Agreement Removed!')
      );
  };

  const deleteSchoolDocs = (id) => {
    dispatch(deleteSchoolDocAsync({ schoolId: branchUniqueId[1], doc: id }))
      .unwrap()
      .then((res) => {
        dispatch(getAllSchoolAsync());
        toast.success('School Document Removed Successfully');
        setHide(false);
      })
      .catch((err) =>
        toast.error('something went wrong, School Document not Removed!')
      );
  };

  const deleteDigital = (id) => {
    dispatch(deleteDigitalAsync({ schoolId: branchUniqueId[1], doc: id }))
      .unwrap()
      .then((res) => {
        dispatch(getAllSchoolAsync());
        toast.success('School Document Removed Successfully');
        setHide(false);
      })
      .catch((err) =>
        toast.error('something went wrong, School Document not Removed!')
      );
  };

  const userMailId =
    singleSchoolData &&
    singleSchoolData.schoolAdmins &&
    singleSchoolData.schoolAdmins[0] &&
    singleSchoolData.schoolAdmins[0].email;

  const adminMsg = () => {
    const payload = {
      adminFeedback: adminMsgs,
      docS3Key: adminFile,
    };
    dispatch(
      updateAdminSchoolDigitalDeliverableAsync({
        schoolId: branchUniqueId[1],
        digital: digitalId,
        data: payload,
      })
    )
      .unwrap()
      .then((res) => {
        dispatch(getAllSchoolAsync());
        toast.success('School admin digital deliverable updated Successfully');
        // send mail api
        sendWelcomeMail(userMailId);
        function sendWelcomeMail(userMailId) {
          // ---------Mail sent-----------------
          let formData = new FormData();
          formData.append('sendMail', 'true');
          formData.append('reciever', userMailId);
          formData.append('sender', 'Teeny Beans');
          formData.append('senderMail', 'no-reply@teenybeans.in');
          formData.append(
            'subject',
            'Your File has been uploaded for Review Purposes'
          );
          formData.append(
            'message',
            `<html>
      <body style="background-color:#f5f8f5;padding:16px;">
      <div style="text-align:center">
        <a href="#"><img style="width:150px;" src="https://teenybeans.in/assets/tb-logo1.png"></a>
      </div>
      <div style="padding-top:16px;">Dear Partner,</div>
      <div style="padding-top:16px;">We are one step closer! Just a quick note to let you know that file has been successfully uploaded for review. The document is now ready for assessment and evaluation.</div>
      <div style="padding-top:16px;">Use the following link to login into partner portal account:</div>
      <div style="padding-top:16px;">URL: <a href="https://portal.teenybeans.in/">https://portal.teenybeans.in/</a><div>
      <div style="padding-top:16px;">Please examine the content we have provided. If any additional information or clarification is required, please reach out to us we will promptly reach out to you.</div>
      <div style="padding-top:16px;">We appreciate your cooperation and look forward to processing the review efficiently.</div>
      <div style="padding-top:16px;">Best regards,</div>
      </body>
      <html>
      `
          );
          fetch('https://mailapi.teenybeans.in/009/', {
            method: 'POST',
            body: formData,
          })
            .then(function (response) {
              response.json().then(function (data) {});
            })
            .catch(function (err) {
              // console.log('Fetch Error :-S', err)
            });
        }
        //
        setShow(false);
        setAdminMsgs('');
        setAdminFile('');
      })
      .catch((err) =>
        toast.error(
          "Current iteration is under review OR Admin can't add new iteration"
        )
      );
  };

  const handleUploadDocument = (e) => {
    const maxSize = 1024 * 1024 * 2;
    if (e.target.files[0].size > maxSize) {
      toast.error('File size exceeds the limit of 2MB');
    } else {
      dispatch(uploadFileAsync({ file: e.target.files[0] }))
        .unwrap()
        .then((res) => {
          setAdminFile(res && res.data && res.data.document);
        });
    }
  };

  const deleteModal = (val) => {
    setHide(true);
    setDocId(val);
  };

  return (
    <>
      {
        <div>
          <div className={classes.containerHeader}>
            <div className={classes.innerContainer}>
              <BranchViewDetailsHeader
                {...{
                  styles: classes,
                  data: singleSchoolData,
                  schoolId: branchUniqueId[1],
                  actions: {},
                }}
              />
            </div>
          </div>
          <Box className={styles.newViewDetailsTab}>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#about"
                onClick={() => {
                  setActiveAgreement(false);
                  setActiveDigital(false);
                  setActiveSchoolDoc(false);
                  setActiveAbout(true);
                }}
                className={
                  activeAbout
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                About
                {activeAbout ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#agreement"
                onClick={() => {
                  setActiveAbout(false);
                  setActiveAgreement(true);
                  setActiveSchoolDoc(false);
                  setActiveDigital(false);
                }}
                className={
                  activeAgreement
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                Agreement Documents
                {activeAgreement ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#digitalDeliverables"
                onClick={() => {
                  setActiveAbout(false);
                  setActiveAgreement(false);
                  setActiveSchoolDoc(false);
                  setActiveDigital(true);
                }}
                className={
                  activeDigital
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                Digital Deliverables
                {activeDigital ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
            <Box className={styles.viewDetailsNavHolder}>
              <a
                href="#schoolDocuments"
                onClick={() => {
                  setActiveDigital(false);
                  setActiveAgreement(false);
                  setActiveAbout(false);
                  setActiveSchoolDoc(true);
                }}
                className={
                  activeSchoolDoc
                    ? styles.viewDetailsNav
                    : styles.viewDetailsNavInactive
                }>
                School Documents
                {activeSchoolDoc ? (
                  <Box className={styles.activeBorderBottom}></Box>
                ) : null}
              </a>
            </Box>
          </Box>
          <Box className={classes.solidBorderBottom}></Box>

          {schoolData ? (
            <Grid
              container
              spacing={3}
              className={classes.viewDetailsSectionContainer}>
              <Grid item xs={8}>
                <Box>
                  <Box id="about" style={{ marginBottom: '3%' }}>
                    {schoolData ? (
                      <AboutDetails
                        {...{
                          styles: classes,
                          data: singleSchoolData,
                          schoolIdParam: branchUniqueId[1],
                        }}
                      />
                    ) : null}
                  </Box>
                </Box>
                <Box
                  id="digitalDeliverables"
                  className={classes.sectionContainer}>
                  <p className={classes.sectionText}>Digital Deliverables</p>
                  <Box>
                    <DigitalDelivarable
                      userMailId={userMailId}
                      schoolId={branchUniqueId[1]}
                    />
                    {singleSchoolData &&
                      singleSchoolData.digitalDeliverables &&
                      singleSchoolData.digitalDeliverables.map((doc) => (
                        <Box border={'1px solid #DFDFDF'} my={1} p={2}>
                          <Grid container spacing={1}>
                            <Grid item xs={2}>
                              <img
                                src={Document}
                                width={'100%'}
                                alt="document"
                              />
                              <a
                                href={
                                  doc.iterations[doc.iterations.length - 1].url
                                }
                                style={{
                                  textDecoration: 'none',
                                  color: 'black',
                                  textAlign: 'center',
                                }}
                                download>
                                <Typography variant="body2">
                                  Download
                                </Typography>
                              </a>
                            </Grid>
                            <Grid item xs={10}>
                              <Box display={'flex'}>
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  onClick={() => {
                                    setShow(true);
                                    setDigitalId(doc._id);
                                  }}>
                                  Update Document
                                </Button>
                                <Box ml={'auto'} display={'flex'}>
                                  <Typography variant="body2">
                                    {doc.status}
                                  </Typography>{' '}
                                  &nbsp; &nbsp; &nbsp;
                                  <Box sx={{ cursor: 'pointer' }}>
                                    <Delete
                                      onClick={() =>
                                        deleteModal({
                                          id: doc._id,
                                          doc: 'digital',
                                        })
                                      }
                                      color="primary"
                                    />
                                  </Box>
                                </Box>
                              </Box>
                              <Typography>
                                <Typography variant="subtitle2">
                                  {doc.title}
                                </Typography>
                                <Box mt={-0.6}>
                                  <Typography variant="body2">
                                    {doc.description}
                                  </Typography>
                                </Box>
                                <Box mt={0.6} />
                                <Box width={600} overflow={'hidden'}>
                                  <Carousel
                                    additionalTransfrom={0}
                                    arrows={false}
                                    draggable
                                    focusOnSelect={false}
                                    minimumTouchDrag={80}
                                    pauseOnHover
                                    responsive={responsive}
                                    showDots
                                    slidesToSlide={1}>
                                    {doc.iterations.map((item) => (
                                      <Box mb={3}>
                                        <Box
                                          bgcolor={'rgb(249, 241, 245)'}
                                          borderRadius={4}
                                          px={2}
                                          py={1}>
                                          <Typography variant="body2">
                                            <Typography variant="subtitle2">
                                              Client FeedBack
                                            </Typography>
                                            {item.clientFeedback}
                                          </Typography>
                                        </Box>
                                        {item.adminFeedback && (
                                          <Box
                                            bgcolor={'rgb(237, 238, 246)'}
                                            borderRadius={4}
                                            px={2}
                                            py={1}
                                            mt={1}
                                            display={'flex'}>
                                            <Typography variant="body2">
                                              <Typography variant="subtitle2">
                                                Admin FeedBack
                                              </Typography>
                                              {item.adminFeedback}
                                            </Typography>
                                            <Box ml={'auto'}>
                                              <a href={item.url} download>
                                                <GetAppIcon color="primary" />
                                              </a>
                                            </Box>
                                          </Box>
                                        )}
                                      </Box>
                                    ))}
                                  </Carousel>
                                </Box>
                              </Typography>
                            </Grid>
                            {show ? (
                              <Box
                                sx={{
                                  position: 'fixed',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  width: 600,
                                  bgcolor: 'white',
                                  p: 2,
                                  borderRadius: 4,
                                  border: '1px solid black',
                                  zIndex: 100,
                                }}>
                                <Box display={'flex'}>
                                  <Typography>Update new Document</Typography>
                                  <Box
                                    ml={'auto'}
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => setShow(false)}>
                                    <CloseIcon />
                                  </Box>
                                </Box>
                                <label>Admin Message</label>
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  value={adminMsgs}
                                  fullWidth
                                  onChange={(e) => setAdminMsgs(e.target.value)}
                                />
                                <Box mt={1} />
                                <label>Upload New Doc.</label>
                                <br />
                                <input
                                  type={'file'}
                                  onChange={(e) => handleUploadDocument(e)}
                                  accept=".pdf, .mp4, .mp3, image/*"
                                />
                                <Box mt={1} />
                                <Button
                                  size="small"
                                  variant="contained"
                                  color="primary"
                                  onClick={adminMsg}
                                  disabled={
                                    adminMsgs === '' || adminFile === ''
                                  }>
                                  Send to Client
                                </Button>
                              </Box>
                            ) : null}
                          </Grid>
                        </Box>
                      ))}
                  </Box>
                  {hide ? (
                    <Box
                      sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'white',
                        p: 2,
                        borderRadius: 4,
                        border: '1px solid black',
                        zIndex: 100,
                      }}>
                      <Box
                        textAlign={'right'}
                        sx={{ cursor: 'pointer' }}
                        onClick={() => setHide(false)}>
                        <CloseIcon />
                      </Box>
                      <Typography>
                        Are you sure you want to delete this document?
                      </Typography>
                      <Box textAlign={'right'} mt={2}>
                        <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          onClick={() => setHide(false)}>
                          Cancel
                        </Button>
                        &nbsp;&nbsp;
                        {docId.doc === 'school' ? (
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => deleteSchoolDocs(docId.id)}>
                            Yes
                          </Button>
                        ) : docId.doc === 'digital' ? (
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => deleteDigital(docId.id)}>
                            Yes
                          </Button>
                        ) : docId.doc === 'agreement' ? (
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => deleteAgreement(docId.id)}>
                            Yes
                          </Button>
                        ) : null}
                      </Box>
                    </Box>
                  ) : null}
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box className={classes.sectionContainer}>
                  <p className={classes.sectionText}>Manage Access</p>
                  {singleSchoolData && singleSchoolData.moduleAccess && (
                    <Grid container spacing={1}>
                      {accessManage.map((item) => (
                        <Grid item xs={item.grid}>
                          <FormControlLabel
                            control={
                              <Checkbox color="primary" checked={item.value} />
                            }
                            label={item.title}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Box>
                <Box id="agreement" className={classes.sectionContainer}>
                  <Box display={'flex'}>
                    <p className={classes.sectionText}>Agreement Documents</p>
                    <Box mt={-1} ml={'auto'}>
                      <UploadDocuments
                        schoolId={branchUniqueId[1]}
                        api={updateSchoolAgreementAsync}
                        type="Agreement"
                      />
                    </Box>
                  </Box>
                  <Box>
                    <Grid container spacing={1}>
                      {singleSchoolData &&
                        singleSchoolData.agreementDocuments &&
                        singleSchoolData.agreementDocuments.map((doc) => (
                          <Grid item xs={6}>
                            <Box
                              border={'1px solid #DFDFDF'}
                              textAlign={'center'}
                              p={1}>
                              <Box
                                textAlign={'right'}
                                style={{ cursor: 'pointer' }}>
                                <Delete
                                  onClick={() =>
                                    deleteModal({
                                      id: doc._id,
                                      doc: 'agreement',
                                    })
                                  }
                                  color="primary"
                                />
                              </Box>
                              <img
                                style={{ marginTop: '-20px' }}
                                src={Document}
                                width={'60%'}
                                alt="document"
                              />
                              <Typography>
                                <b style={{ fontWeight: 500 }}>
                                  {doc.title.substring(0, 20)}
                                </b>
                              </Typography>
                              <a
                                href={doc.url}
                                style={{
                                  textDecoration: 'none',
                                  color: 'black',
                                }}
                                download>
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined">
                                  Download
                                </Button>
                              </a>
                            </Box>
                          </Grid>
                        ))}
                    </Grid>
                  </Box>
                </Box>
                <Box id="schoolDocuments" className={classes.sectionContainer}>
                  <Box display={'flex'}>
                    <p className={classes.sectionText}>School Documents</p>
                    <Box mt={-1} ml={'auto'}>
                      <UploadDocuments
                        schoolId={branchUniqueId[1]}
                        api={updateSchoolDocsAsync}
                        type="Docs"
                      />
                    </Box>
                  </Box>
                  <Box>
                    <Grid container spacing={1}>
                      {singleSchoolData &&
                        singleSchoolData.schoolDocuments &&
                        singleSchoolData.schoolDocuments.map((doc) => (
                          <Grid item xs={6}>
                            <Box
                              border={'1px solid #DFDFDF'}
                              textAlign={'center'}
                              p={1}>
                              <Box
                                textAlign={'right'}
                                sx={{ cursor: 'pointer' }}>
                                <Delete
                                  //
                                  onClick={() =>
                                    deleteModal({ id: doc._id, doc: 'school' })
                                  }
                                  color="primary"
                                />
                              </Box>
                              <img
                                src={Document}
                                width={'60%'}
                                alt="document"
                              />
                              <Typography>
                                <b style={{ fontWeight: 500 }}>
                                  {doc.title.substring(0, 20)}
                                </b>
                              </Typography>
                              <a
                                href={doc.url}
                                style={{
                                  textDecoration: 'none',
                                  color: 'black',
                                }}
                                download>
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined">
                                  Download
                                </Button>
                              </a>
                            </Box>
                          </Grid>
                        ))}
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          ) : null}
        </div>
      }
    </>
  );
};

export default ViewDetails;
